/* eslint-disable react-hooks/exhaustive-deps */
import { Box, makeStyles } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import Message from './Message';
import propTypes from 'prop-types';
import { useFirestore } from 'react-redux-firebase';
import moment from 'moment';
import 'moment/locale/es';

const useStyles = makeStyles({
  scroll: {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: '16px',
    marginLeft: '8px',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: (props) => props.scrollColor,
    },
  },
});

const Props = {
  color: propTypes.string.isRequired,
  image: propTypes.string,
  initialMessages: propTypes.array,
  chatConfiguration: propTypes.shape({
    id: propTypes.string.isRequired,
    session: propTypes.string.isRequired,
  }),
  chatId: propTypes.string,
  tempMsgs: propTypes.array,
  clearTemp: propTypes.func,
  onSendMessage: propTypes.func,
};

function Chat(props) {
  const messagesEndRef = useRef(null);
  const [chat, setChat] = useState();
  const firestore = useFirestore();
  const scrollToBottom = () => {
    const scrollingElement = messagesEndRef.current;
    scrollingElement.scrollTop = scrollingElement.scrollHeight;
  };

  useEffect(() => {
    let unsubscribe;
    if (props.chatId) {
      unsubscribe = firestore
        .collection('chats')
        .doc(props.chatConfiguration.id)
        .onSnapshot((res) => {
          const _chat = res.data();
          setChat(_chat);
        });
    }
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [props.chatId]);

  useEffect(() => {
    props.clearTemp();
  }, [chat]);

  useEffect(() => {
    scrollToBottom();
  }, [chat, props.tempMsgs]);

  const classes = useStyles({ scrollColor: props.color });
  const messages = chat
    ? [...props.initialMessages, ...chat.messages, ...props.tempMsgs]
    : [...props.initialMessages, ...props.tempMsgs];
  return (
    <Box ref={messagesEndRef} className={classes.scroll} flexGrow={1}>
      {messages
        .filter((e) => !(e.type === 2 && e.email))
        .map(({ message, creationDate, type, contentType, hasDownload }, index) => (
          <Message
            hasDownload={hasDownload || false}
            message={message}
            date={moment(creationDate && creationDate.seconds * 1000).format('LLL')}
            forMe={type !== 2}
            contentType={contentType}
            key={index}
            image={props.image}
            onSendMessage={props.onSendMessage}
          />
        ))}
    </Box>
  );
}

Chat.propTypes = Props;

export default Chat;
